import React from "react";

const personas = [
    {
        tag: "01 / Sales",
        title: "Small B2B sales teams",
        body: "Build territory lists by city and category — without burning a day on Google.",
    },
    {
        tag: "02 / Local",
        title: "Local service providers",
        body: "Reach businesses in your delivery radius with a defensible, repeatable workflow.",
    },
    {
        tag: "03 / Agencies",
        title: "Agencies building prospect lists",
        body: "Run dozens of vertical searches, dedupe, and hand off clean lists to clients.",
    },
    {
        tag: "04 / Trade",
        title: "Manufacturers & suppliers",
        body: "Find trade contacts and surface buying signals in fragmented sectors.",
    },
];

export default function Personas() {
    return (
        <section
            data-testid="personas-section"
            className="border-b border-border bg-bg"
        >
            <div className="mx-auto max-w-[1440px] px-6 md:px-12 lg:px-16 py-20 md:py-28">
                <div className="grid lg:grid-cols-12 gap-12">
                    <div className="lg:col-span-4">
                        <span className="overline">Who it's for</span>
                        <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight mt-4 leading-[1.05] text-ink">
                            Built for teams who treat prospecting as a craft.
                        </h2>
                        <p className="mt-6 text-ink-soft text-base md:text-lg max-w-md">
                            ReachForge is for operators who want signal, not
                            scale-at-all-costs. No shared bulk sender. No data
                            you can't audit. Your own infrastructure, your own
                            standards.
                        </p>
                    </div>
                    <div className="lg:col-span-8">
                        <div className="grid sm:grid-cols-2 grid-skeleton border border-border">
                            {personas.map((p) => (
                                <div
                                    key={p.tag}
                                    data-testid={`persona-${p.tag.split(" ")[0]}`}
                                    className="p-8 md:p-10 group hover:bg-surface transition-colors duration-200"
                                >
                                    <span className="overline">{p.tag}</span>
                                    <h3 className="font-display text-2xl font-semibold mt-3 text-ink">
                                        {p.title}
                                    </h3>
                                    <p className="mt-3 text-ink-soft leading-relaxed">
                                        {p.body}
                                    </p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
